'use client'
import React, { ReactElement } from 'react'
import { Layouts } from '../../../types/Layouts'
import { FullWidthLayout, SidebarRightLayout } from './layouts'

interface PageLayoutProps {
    layout?: Layouts
    children: React.ReactNode
    width: PageLayoutWidth
    sidebarChildren?: React.ReactNode[]
}

const layoutComponents = {
    [Layouts.SIDEBAR_RIGHT]: SidebarRightLayout,
    [Layouts.FULL_WIDTH]: FullWidthLayout,
}

export enum PageLayoutWidth {
    XS = 'page-width-xs',
    SM = 'page-width-sm',
    MD = 'page-width-md',
    LG = 'page-width-lg',
    XL = 'page-width-xl',
    FULL = 'page-width-full',
}

const DefaultLayout = Layouts.SIDEBAR_RIGHT

export const PageLayout = ({
    layout = DefaultLayout,
    children,
    sidebarChildren,
    width = PageLayoutWidth.MD,
}: PageLayoutProps): ReactElement => {
    const PageLayoutComponent = layoutComponents[layout in Layouts ? layout : DefaultLayout]
    return <PageLayoutComponent children={children} width={width} sidebarChildren={sidebarChildren} />
}
